// Context
import { AssetsProvider } from "../../contexts/assets/assets.context";

// COMPONENTS
import AssetsPage from "./page.assets.page";
import LoggedIn from "../../layouts/loggedIn.layout";

const AssetsLayout = () => {
  return (
    <LoggedIn>
      <AssetsProvider>
        <AssetsPage />
      </AssetsProvider>
    </LoggedIn>
  );
};

export default AssetsLayout;
